import React from "react"
import Layout from "../components/Layout"
import "../css/projects/py_proj1.css"
import { Link } from "gatsby"
import { FaCode } from "react-icons/fa"
import SEO from "../components/SEO"
import Particle8 from "../components/Particle8"

const Py_proj26 = () => {
  return (
    <Layout>
      <SEO title="Crowd Computing" description="Awesome python project" />
      <Particle8></Particle8>
      <h6>s</h6>

      <section className="noSelect">
        <Link to="/pythonprojectcard/">
          <button type="button" className="back-btn noSelect">
            <span>{"<"}= More Projects</span>
          </button>
        </Link>
      </section>

      <section className="proj-name-wrap noSelect">
        <div className="pyt-img-26">
          <div className="py-1-heading">
            <h1>Crowd Computing</h1>
          </div>
        </div>
        <div className="git">
          <a
            href="https://github.com/arpitsomani8/Python-Programming-Projects/tree/master/Crowd%20Computing"
            target="_blank"
            rel="noopener noreferrer"
            title="Github code"
          >
            <FaCode className="git-btn"></FaCode>
          </a>
        </div>

        <div className="proj-1">
          <div className="p1">
            <h3>Concept Behind It :</h3>
            <p>
              Idea is :-
              <br />
              Take a jar full of choclates, and ask people to give an idea
              <br />
              on number of choclates in the jar.
              <br />
              (Let we ask 100 people)
              <br />
              <br />
              Now take trimmed value of above obtained list
              <br />
              Trimmed means first sort the data then extract 10%
              <br />
              smallest and 10% largest values.
              <br />
              Now, take mean and get estimated value.
              <br />
              <br />
              It would definately a approx value to the original no. of
              chocolate.
              <br />
              <br />
              I did it in 2 flavours :-
              <br />
              First with Statistics module
              <br /> and secondly using Scipy module.
            </p>

            <h3>Skills Behind It :</h3>
            <div className="py-skill-1">
              <button type="button" className="btn-py-1" disabled>
                <span>Statistics</span>
              </button>
              <button type="button" className="btn-py-1" disabled>
                <span>Mean</span>
              </button>
              <button type="button" className="btn-py-1" disabled>
                <span>Scipy</span>
              </button>
              <button type="button" className="btn-py-1" disabled>
                <span>Stats</span>
              </button>
              <button type="button" className="btn-py-1" disabled>
                <span>Python</span>
              </button>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default Py_proj26
